import { FC } from 'react';
import { Icon, IconName } from './icons/Icon';
import { useGamenics, GamenicsEvent } from '../hooks/useGamenics';
import clsx from 'clsx';

interface MobileTabBarProps {
    location: string;
    onNavigate: (path: string) => void;
    isLoggedIn: boolean;
    onLoginClick: () => void;
}

// モバイル用下部タブバー（<md ではヘッダーのnavが消えるため、全主要導線をここで担保する）
export const MobileTabBar: FC<MobileTabBarProps> = ({ location, onNavigate, isLoggedIn, onLoginClick }) => {
    const { playSound } = useGamenics();

    const go = (path: string, scrollToThemes = false) => {
        playSound(GamenicsEvent.TAP_CONFIRM);
        onNavigate(path);
        if (scrollToThemes) {
            setTimeout(() => document.getElementById('themes')?.scrollIntoView({ behavior: 'smooth' }), 100);
        }
    };

    const tabs: { key: string; label: string; icon: IconName; active: boolean; onClick: () => void }[] = [
        { key: 'home', label: 'ホーム', icon: 'star', active: location === '/', onClick: () => go('/') },
        { key: 'search', label: 'さがす', icon: 'search', active: false, onClick: () => go('/', true) },
        // 掲示板（2026-08-14 導線強化）。/board と /salon/board 等の町別掲示板の両方で点灯させる
        { key: 'board', label: '掲示板', icon: 'message', active: location.includes('/board'), onClick: () => go('/board') },
        { key: 'market', label: 'マーケット', icon: 'gift', active: location.startsWith('/market'), onClick: () => go('/market') },
        { key: 'ranking', label: 'ランキング', icon: 'award', active: location.startsWith('/ranking'), onClick: () => go('/ranking') },
        isLoggedIn
            ? { key: 'mypage', label: 'マイページ', icon: 'user', active: location.startsWith('/mypage'), onClick: () => go('/mypage') }
            : { key: 'login', label: 'ログイン', icon: 'user', active: false, onClick: () => { playSound(GamenicsEvent.TAP_CONFIRM); onLoginClick(); } },
    ];

    return (
        <nav
            aria-label="モバイルナビゲーション"
            className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-cream/95 backdrop-blur-md border-t-2 border-ink flex"
        >
            {tabs.map(tab => (
                <button
                    key={tab.key}
                    onClick={tab.onClick}
                    aria-current={tab.active ? 'page' : undefined}
                    className={clsx(
                        'flex-1 min-h-[56px] py-1.5 flex flex-col items-center justify-center gap-0.5',
                        'text-[10px] font-display font-bold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
                        tab.active ? 'text-primary' : 'text-ink-2'
                    )}
                >
                    <Icon name={tab.icon} size={20} />
                    {tab.label}
                </button>
            ))}
        </nav>
    );
};
